import { QuotationDTO } from 'components/ordering/quotation/api/dtos/quotation-dto.js'


export const isQuotationDTO = (quotation: unknown): quotation is QuotationDTO => {
  return quotation instanceof QuotationDTO
}
